import type { InjectionKey } from 'vue'

export const cancelChangeIsOpenKey = Symbol() as InjectionKey<Ref<boolean>>
export const headingKey = Symbol() as InjectionKey<Ref<string>>
export const isEditingKey = Symbol() as InjectionKey<Ref<boolean>>
export const stepKey = Symbol() as InjectionKey<Ref<number>>
export const showContinueModalKey = Symbol() as InjectionKey<Ref<boolean>>
